import { Navigate, RouteObject } from 'react-router-dom';
import { RootLayout } from '@/layouts/RootLayout';
import { WorkspaceLayout } from '@/layouts/WorkspaceLayout';
import { DashboardLayout } from '@/layouts/DashboardLayout';
import { AuthGuard } from '@/components/AuthGuard';
import { HomePage } from '@/pages/HomePage';
import { SignInPage } from '@/pages/SignInPage';
import { CreateWorkspacePage } from '@/pages/CreateWorkspacePage';
import { TicketsPage } from '@/pages/workspace/TicketsPage';
import { TicketDetailPage } from '@/pages/workspace/TicketDetailPage';
import { KnowledgeBasePage } from '@/pages/workspace/KnowledgeBasePage';
import { SettingsPage } from '@/pages/workspace/settings/SettingsPage';

export const ROUTES = {
  HOME: '/',
  SIGN_IN: '/sign-in',
  CREATE_WORKSPACE: '/create-workspace',
  WORKSPACE: '/workspace/:id',
  WORKSPACE_TICKETS: '/workspace/:id/tickets',
  WORKSPACE_TICKET_DETAIL: '/workspace/:id/tickets/:ticketId',
  WORKSPACE_KNOWLEDGE_BASE: '/workspace/:id/knowledge-base',
  WORKSPACE_PROJECTS: '/workspace/:id/projects',
  WORKSPACE_INTEGRATIONS: '/workspace/:id/integrations',
  WORKSPACE_INTEGRATION_DETAIL: '/workspace/:id/integrations/:integrationId',
  WORKSPACE_INTEGRATION_ACCOUNT_DETAIL: '/workspace/:id/integrations/:integrationId/:accountId',
  WORKSPACE_SETTINGS: '/workspace/:id/settings',
  WORKSPACE_SETTINGS_TAB: '/workspace/:id/settings/:tabId'
} as const;

export const routes: RouteObject[] = [
  {
    element: <RootLayout />,
    children: [
      // Public routes
      { path: ROUTES.SIGN_IN, element: <SignInPage /> },
      { path: ROUTES.CREATE_WORKSPACE, element: <CreateWorkspacePage /> },

      // Protected routes
      {
        path: ROUTES.HOME,
        element: (
          <AuthGuard>
            <HomePage />
          </AuthGuard>
        )
      },
      {
        path: ROUTES.WORKSPACE,
        element: (
          <AuthGuard>
            <WorkspaceLayout />
          </AuthGuard>
        ),
        children: [
          { index: true, element: <Navigate to="tickets" replace /> },
          // Dashboard routes (with DashboardSidebar)
          {
            element: <DashboardLayout />,
            children: [
              { path: 'tickets', element: <TicketsPage /> },
              { path: 'tickets/:ticketId', element: <TicketDetailPage /> },
              { path: 'knowledge-base', element: <KnowledgeBasePage /> },
              { path: 'projects', element: <Navigate to="../settings/projects" replace /> }
            ]
          },
          // Settings routes (SettingsPage has its own layout)
          {
            path: 'settings',
            children: [
              { index: true, element: <SettingsPage /> },
              { path: 'team/:teamId', element: <SettingsPage /> },
              { path: ':tabId', element: <SettingsPage /> },
              { path: 'integrations/:integrationId', element: <SettingsPage /> },
              { path: 'integrations/:integrationId/:accountId', element: <SettingsPage /> }
            ]
          }
        ]
      },
      { path: '*', element: <Navigate to="/" replace /> }
    ]
  }
];
